import { supabase } from './supabase';
import type { Session } from '@supabase/supabase-js';

// Real admin authentication via Supabase Auth. A signed-in session is what lets
// admin writes pass the database's row-level security policies.

export async function signIn(email: string, password: string) {
  const { data, error } = await supabase.auth.signInWithPassword({ email, password });
  if (!error && data.session) {
    sessionStorage.setItem('admin_logged_in', 'true'); // keeps existing page guards happy
  }
  return { session: data.session, error };
}

export async function signOut(): Promise<void> {
  await supabase.auth.signOut();
  sessionStorage.removeItem('admin_logged_in');
}

export async function getSession(): Promise<Session | null> {
  const { data } = await supabase.auth.getSession();
  return data.session;
}

export function onAuthChange(cb: (session: Session | null) => void) {
  const { data } = supabase.auth.onAuthStateChange((_event, session) => cb(session));
  return () => data.subscription.unsubscribe();
}
